import { Labels } from '@/core';
import { GlobalFilter } from '@/plugin-system/runtime/GlobalFilters';

/**
 * Converts a Labels object to an array of GlobalFilter objects.

 */
export function labelsToFilters(labels: Labels, args?: { matcher?: GlobalFilter['matcher'] }): GlobalFilter[] {
  const matcher = args?.matcher ?? '=';
  return Object.entries(labels).map(([key, value]) => {
    return {
      label: key,
      matcher: matcher,
      value: value ?? '',
    } as GlobalFilter;
  });
}
